import { LegacyIIQApi } from '../legacy-iiq-api'

const formatResponse = ({
  data,
  errors,
}: {
  data: Record<string, any>
  errors: any[]
}) => ({ ...data, errors })

export const createOrgAppSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (body: Record<string, any> = {}) =>
    api
      .post<Record<string, any>>(`/org-app-settings`, body)
      .then(formatResponse)

export const getAllOrgAppSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (params: Record<string, any> = {}) =>
    api
      .get<Record<string, any>>('/org-app-settings', params)
      .then(formatResponse)

export const updateOrgAppSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (orgAppSettingsId: string, params: Record<string, any> = {}) =>
    api
      .patch<Record<string, any>>(
        `/org-app-settings/${orgAppSettingsId}`,
        params,
      )
      .then(formatResponse)

export const deleteOrgAppSettings =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (orgAppSettingsId: string, params: Record<string, any> = {}) =>
    api
      .delete<Record<string, any>>(
        `/org-app-settings/${orgAppSettingsId}`,
        params,
      )
      .then(formatResponse)
